export const smoothstep = function (min: number, max: number, value: number) {
  const x = Math.max(0, Math.min(1, (value - min) / (max - min)))
  return x * x * (3 - 2 * x)
}

export const easeOut = function (t: number, power: number) {
  return 1 - Math.pow(1 - t, power)
}

export const easeIn = function (t: number, power: number) {
  return Math.pow(t, power)
}

export const easeInOut = function (t: number, power: number) {
  if (t < 0.5) return easeIn(t * 2.0, power) / 2.0
  return 1 - easeIn((1 - t) * 2, power) / 2
}

export const mapToRange = function (dropDownValue: number, rangeMin: number, rangeMax: number) {
  const valueMin = 1
  const valueMax = 10
  const percent = (dropDownValue - valueMin) / (valueMax - valueMin)
  return Math.max(percent * (rangeMax - rangeMin) + rangeMin, 0.0001)
}

const randomSequence: number[] = []
for (let i = 1e5; i > 0; i--) {
  randomSequence.push(Math.random() - 0.5)
}

let randomIndex = 0

export const Random = {
  next: function () {
    randomIndex++
    if (randomIndex >= randomSequence.length) {
      randomIndex = 0
    }
    return randomSequence[randomIndex]
  }
}

/**
 * Drop-in replacement of standard lerp with optional frame delta and target fps
 * to maintain constant animation speed at various fps
 *
 * Based on http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
 *
 * @param {number} source Current value
 * @param {number} target Value to lerp towards
 * @param {number} rate Interpolation rate
 * @param {number} frameDelta Optional frame delta time in seconds. Should be 1/60 for a steady 60fps.
 * @param {number} targetFps Optional, target is 60 by default
 * @returns {number} interpolated value
 */

function _lerp(v0: number, v1: number, t: number) {
  return v0 * (1 - t) + v1 * t
}

export function lerp(source: number, target: number, rate: number, frameDelta: number, targetFps = 60) {
  if (typeof frameDelta === 'undefined') {
    return _lerp(source, target, rate)
  }

  const relativeDelta = frameDelta / (1 / targetFps)
  const smoothing = 1 - rate
  return _lerp(source, target, 1 - Math.pow(smoothing, relativeDelta))
}
